import { createContext, useContext } from 'react';
import { nanoid } from 'nanoid';

import type { SnackbarProps } from './types';

type ContextProps = {
  snackbar: SnackbarProps | null;
  onAdd: (v: SnackbarProps) => void;
  onDelete: () => void;
};

export const SnackbarContext = createContext<ContextProps | null>(null);

export const useSnackbarContext = () => {
  const snackbar = useContext(SnackbarContext);
  if (!snackbar) throw Error(`snackbar not defined`);

  return snackbar;
};

export const useSnackbar = () => {
  const { onAdd } = useSnackbarContext();
  return function snackbar(v: SnackbarProps) {
    const id = nanoid();

    onAdd({
      ...v,
      id,
    });
  };
};
